export default __webpack_public_path__ + "static/media/ReportExample1.f95e58cd.png";